import { Star } from "iconsax-react";
import React from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from 'react-type-animation';


const HeroSection = () => {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-16 flex flex-col md:flex-row items-center gap-12 bg-[url('./assets/images/dots.png')]">
      <div className="flex-1">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
          Empowering Your Financial <span className="text-[#32AE4C]"><TypeAnimation
  sequence={['Freedom', 500, 'Growth', 500, 'Success', 500, 'Journey', 500, 'Stability', 500]}
  repeat={Infinity}
/></span>
        </h1>
        <p className="mt-6 text-lg text-gray-600 max-w-lg">
          Take control of your finances with ease. Join millions of users who
          trust Vant for seamless money management and smart investing.
        </p>

        <div className="mt-10 flex flex-wrap gap-4">
       <a
            href="https://www.google.com/url?q=https://play.google.com/store/apps/details%3Fid%3Dcom.vant.app%26hl%3Den_US%26referrer%3Dutm_source%253Dgoogle%2526utm_medium%253Dorganic%2526utm_term%253Dvant%2Bapp&sa=U&ved=2ahUKEwixkrSIwpqBAxVgU0EAHVPRDAMQFnoECAUQAg&usg=AOvVaw3iL8zaaBsLYYudFsvEMTLY "
            target="_blank"
            rel="noopener noreferrer"
          >
          <img
            src={"./assets/goggle.svg"}
            className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
            alt="playstore_img"
          /></a>

           <a
            href="https://apps.apple.com/ng/app/vant-app/id6464392721"
            target="_blank"
            rel="noopener noreferrer"
          >
          <img
            src={"./assets/app.svg"}
            className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
            alt="appstore_img"
          /></a>
        </div>

        <div className="mt-8 flex items-center gap-4">
          <div className="">
            <img
              className="h-8  lg:h-[38px] rounded-full border-2 border-white"
              src="./assets/Avatars.svg"
              alt="User"
            />
          </div>
          <div>
            <div className="flex gap-1 items-center">
              <Star color="yellow" variant="Bold" className="h-4 md:h-6" />
              <Star color="yellow" variant="Bold" className="h-4 md:h-6" />
              <Star color="yellow" variant="Bold" className="h-4 md:h-6" />
              <Star color="yellow" variant="Bold" className="h-4 md:h-6" />
              <Star color="#EAEAEA" variant="Bold" className="h-4 md:h-6" />
            </div>
            <p className="text-xs md:text-sm text-gray-600">
          from 800+ reviews
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 relative">
          <img
            src="./assets/personalHero.svg"
            alt="Vant App"
            className="w-full h-[360px] md:h-[420px] lg:h-auto "
          />
      </div>
    </section>
  );
};

export default HeroSection;
